import Vue from 'vue';
import VueRouter from 'vue-router';
import ReferencesPage from '@/views/ReferencesPage.vue';
import ExplorerPage from '@/views/ExplorerPage.vue';
import HomePage from '@/views/HomePage.vue';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Explorer',
            component: ExplorerPage
        }
    ]
});

// router.afterEach((to) => {
//     sendAnalyticsPageview(to);
// });

// const GA_MEASUREMENT_ID = 'UA-154436227-1';

// function sendAnalyticsPageview(to) {
//     // implemented following Google documentation
//     // https://developers.google.com/analytics/devguides/collection/gtagjs/pages
//     const pageInfo = {
//         page_path: to.path,
//         page_title: to.name
//     }
//     gtag('config', GA_MEASUREMENT_ID, pageInfo);
// }

export default router;